import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { CloudForwarderForwarderInputProfiles } from "@graylog/enterprise-api";
const inputProfileBatcher = create({
  fetcher: async (ids) => CloudForwarderForwarderInputProfiles.getByIds({ input_profile_ids: ids }),
  resolver: keyResolver("id"),
  scheduler: windowScheduler(10)
});
const useInputProfile = (profileId) => {
  const { data, isFetching } = useQuery({
    queryKey: ["forwarder", "input-profiles", profileId],
    queryFn: () => inputProfileBatcher.fetch(profileId),
    placeholderData: keepPreviousData
  });
  return { data, isFetching };
};
export default useInputProfile;
